export const CircledClose = ({ width = '100%', height = '100%', ...props }: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}>
            <path
                d="M0 16C0 7.16344 7.16344 0 16 0V0C24.8366 0 32 7.16344 32 16V16C32 24.8366 24.8366 32 16 32V32C7.16344 32 0 24.8366 0 16V16Z"
                fill="white"
            />
            <path
                d="M9.98958 9.98959C10.1848 9.79433 10.5014 9.79433 10.6967 9.98959L16 15.2929L21.3033 9.98959C21.4986 9.79433 21.8151 9.79433 22.0104 9.98959C22.2057 10.1849 22.2057 10.5014 22.0104 10.6967L16.7071 16L22.0104 21.3033C22.2057 21.4986 22.2057 21.8151 22.0104 22.0104C21.8151 22.2057 21.4986 22.2057 21.3033 22.0104L16 16.7071L10.6967 22.0104C10.5014 22.2057 10.1848 22.2057 9.98958 22.0104C9.79432 21.8151 9.79432 21.4986 9.98958 21.3033L15.2929 16L9.98958 10.6967C9.79432 10.5014 9.79432 10.1849 9.98958 9.98959Z"
                fill="#1E1E1E"
            />
        </svg>
    );
};
